import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=1273cf77&scoped=true&"
import script from "./home-page.vue?vue&type=script&lang=js&"
export * from "./home-page.vue?vue&type=script&lang=js&"
import style0 from "./home-page.vue?vue&type=style&index=0&id=1273cf77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1273cf77",
  null
  
)

export default component.exports